import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonToolbar,
  Form,
  Loader,
  Container,
  Content,
  Checkbox,
  Modal,
} from "rsuite";
import { ProductServices } from "../../../core/services/ProductServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import "./Products.css";
import { useSelector } from "react-redux";
import {
  onOffArr,
  productGenderObjArr,
  productNatureObjArr,
} from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import {
  displayField,
  getAvailableDaysLabel,
  getFoodTypeLabel,
  getLabelFor,
  getSizeLabel,
  getStatusLabel,
  processProductTypeFields,
} from "../../../utils/helpers";
import { get } from "lodash/fp";

const ViewCompanyProductModal = (props: any) => {
  const { t } = useTranslation();

  const productViewId = useSelector((state: any) => {
    return state?.actionData?.id;
  });

  const [loader, setLoader] = useState(false);
  const [productInfo, setProductInfo] = useState<any>({});
  const [productTypeFieldDetails, setProductTypeFieldDetails] = useState<any>(
    []
  );
  const [productTypeFieldNames, setProductTypeFieldNames] = useState<any>([]);

  async function getProductTypeFields(id: number) {
    try {
      setLoader(true);
      const res = await ProductServices.getProductTypeFields(id);
      const validFieldsDetails = processProductTypeFields(get(res.data.data));
      setLoader(false);
      setProductTypeFieldDetails(validFieldsDetails);
      setProductTypeFieldNames(validFieldsDetails.keys());
    } catch (error) {
      setLoader(false);
    }
  }

  async function getViewProductDetail(id: number) {
    try {
      setLoader(true);
      const res = await ProductServices.viewCompanyProduct(id);

      setLoader(false);
      if (res && res.data && res.data.data) {
        setProductInfo({ ...res.data.data });
      }
    } catch (error) {
      setLoader(false);
    }
  }
  useEffect(() => {
    getViewProductDetail(productViewId);
  }, []);

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Modal
        open={props.status}
        backdrop={false}
        onClose={(e: any) => {
          props.toggle("");
        }}
      >
        <Modal.Header>
          <h4 className="text-center">
            {t("VIEW")} {t("DETAIL")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="products view-products">
            <Container className="container">
              {productInfo &&
              Object.keys(productInfo).length &&
              productTypeFieldDetails ? (
                <Content>
                  <Form layout="inline">
                    <div className="view-prd-profile text-center">
                      <div>
                        <img
                          src={
                            productInfo && productInfo?.image_url
                              ? productInfo.image_url
                              : UtilityServices.getLoggedInUser(
                                  "product_default_image"
                                )
                          }
                          alt=""
                        />
                      </div>
                    </div>
                    <Form.Group controlId="product_name">
                      <Form.ControlLabel>{t("NAME")} : </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${productInfo?.product?.product_name}`)}{" "}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="product_sku">
                      <Form.ControlLabel>{t("SKU")}</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${productInfo?.product?.product_sku}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="product_type_name">
                      <Form.ControlLabel>
                        {t("PRODUCT")} {t("TYPE")}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          `${productInfo?.product?.product_type?.product_type_name}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="cat_name">
                      <Form.ControlLabel>{t("CATEGORY")}</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          `${productInfo?.product?.product_category?.cat_name}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="product_nature">
                      <Form.ControlLabel>
                        {t("PRODUCT")} {t("NATURE")}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          getLabelFor(
                            productInfo?.product?.product_nature,
                            productNatureObjArr
                          )
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="product_for_gender">
                      <Form.ControlLabel>
                        {t("FOR")} {t("GENDER")}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          getLabelFor(
                            productInfo?.product?.product_for_gender,
                            productGenderObjArr
                          )
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="company_product_orginal_price">
                      <Form.ControlLabel>
                        {t("ORIGINAL")} {t("PRICE")}{" "}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          `${productInfo?.company_product_orginal_price}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="company_product_price">
                      <Form.ControlLabel>{t("PRICE")} </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${productInfo?.company_product_price}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="competitor_price">
                      <Form.ControlLabel>
                        {t("COMPETITOR")} {t("PRICE")}{" "}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          `${productInfo?.company_competitor_price}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="company_product_cost">
                      <Form.ControlLabel>
                        {t("PRODUCT")} {t("COST")}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${productInfo?.company_product_cost}`)}
                        {productInfo?.company_product_cost_percent && (
                          <> ({productInfo?.company_product_cost_percent}%)</>
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="company_product_cost_detail">
                      <Form.ControlLabel>
                        {t("PRODUCT")} {t("COST")} {t("DETAIL")}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          `${productInfo?.company_product_cost_detail}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="product_detail" className="mt-2">
                      <Form.ControlLabel>{t("DESCRIPTION")}</Form.ControlLabel>
                      <Form.ControlLabel>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: displayField(
                              productInfo?.company_product_detail
                            ),
                          }}
                        />
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="care_detail" className="mt-2 mb-3">
                      <Form.ControlLabel>
                        {t("CARE")} {t("DETAIL")}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${productInfo?.company_care_detail}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="special_note">
                      <Form.ControlLabel>
                        {t("SPECIAL")} {t("NOTE")}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${productInfo?.company_special_note}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="hygenic_index">
                      <Form.ControlLabel>
                        {t("HYGENIC")} {t("INDEX")}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${productInfo?.company_hygenic_index}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="process_time">
                      <Form.ControlLabel>
                        {t("PROCESS")} {t("TIME")}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${productInfo?.company_process_time}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="food_type">
                      <Form.ControlLabel>
                        {t("FOOD")} {t("TYPE")}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          getFoodTypeLabel(`${productInfo?.product?.food_type}`)
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="size">
                      <Form.ControlLabel>{t("SIZE")}</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          getSizeLabel(`${productInfo?.product?.size}`)
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="available_on_day">
                      <Form.ControlLabel>
                        {t("AVAILABLE")} {t("ON")}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          getAvailableDaysLabel(
                            `${productInfo?.company_available_on_day}`
                          )
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="status">
                      <Form.ControlLabel>{t("STATUS")}</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(getStatusLabel(`${productInfo?.status}`))}
                      </Form.ControlLabel>
                    </Form.Group>
                  </Form>
                </Content>
              ) : null}
            </Container>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ViewCompanyProductModal;
